module.exports = __webpack_public_path__ + "img/banner-img1x.6cbc487f.png";